module.exports = __webpack_public_path__ + "img/overview.ceeca53c.svg";